import { render, staticRenderFns } from "./RadioSelectForm.vue?vue&type=template&id=284127f3"
import script from "./RadioSelectForm.vue?vue&type=script&lang=js"
export * from "./RadioSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports